$(function() {
    $(".sidenav ul > li.expandable > a").append('<span class="expander opensubmenu"></span>');
    $(".sidenavsubmenu").prepend('<span class="back closesubmenu">Back</span><span class="close closemenu">Close</span>');

    const $menuItems = $('ul.mainmenu > li.expandable');

    function openSubmenu($submenu) {
        $submenu.css('width', $(window).width() < 769 ? '100%' :'50%');
        $submenu.find('.sidenavsubmenuinner > ul').stop(true, true).delay(300).fadeIn(200);
    }
    function closeSubmenu($submenu) {
        $submenu.find('.sidenavsubmenuinner > ul').stop(true, true).hide();
        $submenu.css('width', '0');
    }

    function openSubmenuMobile($submenu) {
        //clearTimeout($submenu.data('hideTimeout'));
        $submenu.css({'left' :'0', 'width' :'100%'});
        $submenu.find('.sidenavsubmenuinner > ul').stop(true, true).delay(300).fadeIn(200);
    }
    function closeSubmenuMobile($submenu) {
        $submenu.find('.sidenavsubmenuinner > ul').stop(true, true).fadeOut(40);
        const t = setTimeout(() => {
            $submenu.css({'left' :'100%', 'width' :'0'});
    }, 100);
        $submenu.data('hideTimeout', t);
    }

    // function closeMainMenu() {
    //     $('body').removeClass('modalopen');
    //     $('.openmenu').removeClass('menuon');
    //     $('.sidenavinnercontent').hide();
    //     $('#sidenav').delay(500).css('width', '0');
    // }

    // $('.openmenu').on('click', function (e) {
    //     e.preventDefault();
    //     if ($(this).hasClass('menuon')) {
    //         $(this).removeClass('menuon');
    //         $('body').removeClass('modalopen');
    //         $('.sidenavinnercontent').hide();
    //         $('#sidenav').delay(500).css('width', '0px');
    //     } else {
    //         $(this).addClass('menuon');
    //         $('body').css("overflow", "unset");
    //         $('body').addClass('modalopen');
    //         $('#sidenav').css('width', '100%');
    //         $('.sidenavinnercontent').delay(300).fadeIn(500);
    //     }
    //     return false;
    // });
    // $('.closebtn').click(function () {
    //     $('body').removeClass('modalopen');
    //     $('.openmenu').removeClass('menuon');
    //     $('.sidenavinnercontent').hide();
    //     $('#sidenav').delay(500).css('width', '0');
    //     return false;
    // });

    // Desktop (hover)
    $menuItems.on('mouseenter', function () {
        if ($(window).width() >= 769) {
            openSubmenu($(this).find('.sidenavsubmenu'));
        }
    }).on('mouseleave', function () {
        if ($(window).width() >= 769) {
            closeSubmenu($(this).find('.sidenavsubmenu'));
        }
    });

    // Mobile (click)
    $('.opensubmenu').on('click', function (e) {
        if ($(window).width() < 769) {
            e.preventDefault();
            const $submenu = $(this).closest('li.expandable').find('.sidenavsubmenu');
            openSubmenuMobile($submenu);
        }
    });
    $('.closesubmenu').on('click', function (e) {
        if ($(window).width() < 769) {
            e.preventDefault();
            const $submenu = $(this).closest('li.expandable').find('.sidenavsubmenu');
            closeSubmenuMobile($submenu);
        }
    });
    $('.closemenu').on('click', function (e) {
        if ($(window).width() < 769) {
            e.preventDefault();
            const $submenu = $(this).closest('li.expandable').find('.sidenavsubmenu');
            closeSubmenuMobile($submenu);
            closeMainMenu();
        }
    });

    $(".sidenavsubmenuinner > ul > li.expandable > a").append('<span class="expander"></span>');
    $('.sidenavsubmenuinner > ul > li.expandable > a > span.expander').click(function () {
        $(this).toggleClass('open');
        $(this).closest('li.expandable').find('ul.subsubmenu:first').slideToggle();
        return false;
    });

    $(window).on('resize', function () {
        if ($(window).width() >= 769) {
            $('.sidenavsubmenu').css({
                'left': '50%',
                'width': '0'
            });
            $('.sidenavsubmenuinner > ul').hide();
        } else {
            $('.sidenavsubmenu').css({
                'left': '100%',
                'width': '0'
            });
            $('.sidenavsubmenuinner > ul').hide();
        }
    }).trigger('resize');

});
